import { render } from "./AddPortModal.vue?vue&type=template&id=13c7a1fb&ts=true"
import script from "./AddPortModal.vue?vue&type=script&lang=ts"
export * from "./AddPortModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__